import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';

import { BrowseCheckbox } from '../BrowseCheckbox';
import { BrowseInputRange } from '../BrowseInputRange';

import style from './style.module.css';

const BrowseProjectDefaultCriteriaFilterComponent = ({ filter, info, onChangeCheckbox, onChangeRange, onChange }) => (
  <BrowseCheckbox filter={filter} info={info} onChange={onChange}>
    <label className={classNames(style.label, 'pt5')}>{filter.getIn(['revenueRange', 'label'])}</label>
    <BrowseInputRange
      filter={filter.get('revenueRange')}
      info={info.get('revenueRange')}
      onChange={onChangeRange}
      hiddenCheckbox
    />
    <label className={style.label}>{filter.getIn(['ebitdaRange', 'label'])}</label>
    <BrowseInputRange
      filter={filter.get('ebitdaRange')}
      info={info.get('ebitdaRange')}
      onChange={onChangeRange}
      hiddenCheckbox
    />
    <label className={style.label}>{filter.getIn(['evRange', 'label'])}</label>
    <BrowseInputRange
      filter={filter.get('evRange')}
      info={info.get('evRange')}
      onChange={onChangeRange}
      hiddenCheckbox
    />
    <div className="row w100p">
      <div className="col-md-6">
        <BrowseCheckbox
          filter={filter.getIn(['transactionTypes', 'buyout'])}
          info={filter.getIn(['transactionTypes', 'buyout'])}
          onChange={onChangeCheckbox}
        />
        <BrowseCheckbox
          filter={filter.getIn(['transactionTypes', 'recap'])}
          info={filter.getIn(['transactionTypes', 'recap'])}
          onChange={onChangeCheckbox}
        />
        <BrowseCheckbox
          filter={filter.getIn(['transactionTypes', 'mezz'])}
          info={filter.getIn(['transactionTypes', 'mezz'])}
          onChange={onChangeCheckbox}
        />
        <BrowseCheckbox
          filter={filter.getIn(['transactionTypes', 'carveout'])}
          info={filter.getIn(['transactionTypes', 'carveout'])}
          onChange={onChangeCheckbox}
        />
      </div>
      <div className="col-md-6">
        <BrowseCheckbox
          filter={filter.getIn(['transactionTypes', 'takeprivate'])}
          info={filter.getIn(['transactionTypes', 'takeprivate'])}
          onChange={onChangeCheckbox}
        />
        <BrowseCheckbox
          filter={filter.getIn(['transactionTypes', 'minority'])}
          info={filter.getIn(['transactionTypes', 'minority'])}
          onChange={onChangeCheckbox}
        />
        <BrowseCheckbox
          filter={filter.getIn(['transactionTypes', 'turnaround'])}
          info={filter.getIn(['transactionTypes', 'turnaround'])}
          onChange={onChangeCheckbox}
        />
      </div>
    </div>
  </BrowseCheckbox>
);

BrowseProjectDefaultCriteriaFilterComponent.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  info: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
};

/** Browse project default criteria filter component. */
export const BrowseProjectDefaultCriteriaFilter = memo(BrowseProjectDefaultCriteriaFilterComponent);
